export default (_, t) => {
  return {
    fields: [
      {
        type: 'group',
        label: t('propsEditor.setBrushStyle'),
        children: [
          {
            as: 'slider',
            label: t('propsEditor.brushWidth'),
            blockLabel: true,
            name: 'brushWidth',
            min: 1,
            descriptions: [t('propsEditor.brushWidthTip')],
          },
        ],
      },
    ],
  };
};
